<template>
    <div>
        <rkm-form ref="RkmForm" v-if="form">
            <rkm-alert
                v-if="form.paciente.isIdoso"
                color="success"
                class="mb-3"
            >
                <rkm-row>
                    <rkm-col>
                        <strong>Acompanhamento do idoso</strong>
                    </rkm-col>
                </rkm-row>
            </rkm-alert>

            <rkm-tabs>
                <rkm-tab title="Histórico">
                    <BoxHistorico
                        :data="historicoData"
                        @atendimento-clicado="logAtendimentoClicado"
                    />
                </rkm-tab>

                <rkm-tab title="Histórico - Santa Casa" v-if="form.exibeHistoricoErpsaude">
                    <BoxHistoricoHospitalSantaCasa :data="historicoData" />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>
// Components.
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index'
import BoxHistoricoHospitalSantaCasa from '@/components/ambulatorio/atendimento/components/historico-hospital-santa-casa/Index'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxHistorico, BoxHistoricoHospitalSantaCasa
    },
    computed: {
        historicoData() {
            return {
                form: this.form,
            }
        },
    },
    created() {
        this.repositories = {
            historico: this.getConectaSusRepository('ambulatorio.historicoAtendimento'),
        }
    },
    data: () => ({
        form: null,
        historicoAtendimentoLogId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        logAtendimentoClicado({item, acao}) {
            this.repositories.historico.logAtendimento(this.id, {
                historico_atendimento_log_id: this.historicoAtendimentoLogId,
                origem: item.origem,
                acao,
                atendimento_id: item.origem === 'ambulatorio' ? item.atendimentoId : item.id,
            }).catch(this.handleError)
        },
        load() {
            this.setLoading()

            this.repositories.historico.show(this.id)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.historicoAtendimentoLogId = response.data.historicoAtendimentoLogId

                    this.$emit('loaded', {form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number, required: true},
    },
}
</script>